import styles from '~/styles/pages/demo.css?url'
import formStyles from '~/styles/components/form.css?url'
import reviewCardStyles from '~/components/cards/review-card/review-card.css?url'
import gridStyles from '~/styles/components/grid.css?url'
import { FormBasics } from '~/components/forms/basics'
import { H1, H2, Stack } from '~/components-v2'
import { G2Reviews } from './_landing.demo'
import { LoaderFunctionArgs } from '@remix-run/node'
import { rudderStack } from '~/utils/rudder-stack.server'
import {
  ActionData,
  handleHubspotFormAction,
  submitToHubspot,
} from '~/utils/hubspot'
import { formSchema } from '~/utils/form-schema'
import { HUBSPOT_PORTAL_ID, HUBSPOT_FORM_ID } from '~/config/form'
import { useActionData } from '@remix-run/react'
export { ErrorBoundary } from './_landing.demo'
export { meta } from '~/utils'
export const links = () => [
  { rel: 'stylesheet', href: formStyles },
  { rel: 'stylesheet', href: reviewCardStyles },
  { rel: 'stylesheet', href: gridStyles },
  { rel: 'stylesheet', href: styles },
]

const title = 'Get started with Omni'
const description = 'Schedule a 1:1 meeting with our team.'

export const loader = async ({ request }: LoaderFunctionArgs) => {
  rudderStack(request, title)
  return { title, description }
}

export const action = handleHubspotFormAction({
  schema: formSchema,
  submitToHubspot,
  formId: HUBSPOT_FORM_ID,
  portalId: HUBSPOT_PORTAL_ID,
  thankYouUrl: '/thankyou',
})

const Headings = () => (
  <Stack as="hgroup" gap={2}>
    <H1 fontSize="xxxl" fontWeight={800}>
      {title}
    </H1>
    <H2 color="text4" fontSize="xl">
      {description}
    </H2>
  </Stack>
)

export default function Component({ children }: { children: React.ReactNode }) {
  const actionData = useActionData<ActionData>()
  return (
    <Stack className="request-demo-wrapper" gap={6} align="center">
      <Headings />
      <section className="demo-page-content">
        <div className="gradients">
          <div className="breeze"></div>
          <div className="dawn"></div>
        </div>
        <article className="form">
          {children}
          <FormBasics
            buttonLabel="Request Demo"
            campaignCode="request-demo-cta"
            actionData={actionData}
          ></FormBasics>
        </article>
      </section>
      <G2Reviews />
    </Stack>
  )
}
